import {
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { Offering } from '../../../models/offering';
import { CommonModule, DatePipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import {
  RdsAvatarModule,
  RdsBadgeModule,
  RdsButtonModule,
  RdsDialogService,
  RdsDropdownModule,
  RdsIconsModule,
  RdsListItemModule,
} from '@rds/angular-components';
import { OverlayModule } from '@angular/cdk/overlay';
import { FocusContributorsDialogComponent } from '../dialogs/focus-contributors-dialog/focus-contributors-dialog.component';
import { EnterToFocusWithinDirective } from '../../../directives/enter-to-focus-within.directive';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';
import { OFFERING_TYPE_ROUTE } from '../../../constants/offering-routes.constants';

@Component({
  selector: 'inexp-focus-card',
  imports: [
    DatePipe,
    RouterModule,
    RdsButtonModule,
    RdsBadgeModule,
    RdsAvatarModule,
    RdsIconsModule,
    OverlayModule,
    EnterToFocusWithinDirective,
    RdsDropdownModule,
    RdsListItemModule,
    CommonModule,
  ],
  templateUrl: './focus-card.component.html',
  styleUrl: './focus-card.component.scss',
})
export class FocusCardComponent {
  offering = input<Offering>();
  dialog = inject(RdsDialogService);
  knowledge = signal<string>('');
  private readonly _router = inject(Router);
  readonly BUTTONS = BUTTON_TEXTS;
  readonly offeringTypeRoute = computed(
    () =>
      OFFERING_TYPE_ROUTE[(this.offering() as any)?.offeringType ?? ''] ??
      'application',
  );

  offeringEffect = effect(() => {
    this.knowledge.set(this.offering()?.knowledge as string);
  });

  handleContributorsDialog() {
    this.dialog
      .open(FocusContributorsDialogComponent, {
        size: 's',
        data: {
          authorEmails: this.offering()?.authorEmails,
          deputyEmail: this.offering()?.deputyEmail,
          ownerEmail: this.offering()?.ownerEmail,
        },
      })
      .afterClosed()
      .subscribe();
  }

  getContentStatusLabel(publishedAt?: string | null, updatedAt?: string | null): string {
    // 1. Draft: The offering has never been published
    if (!publishedAt) {
      return 'Draft';
    }

    const getSecondsOnly = (dateStr: string) => {
      const d = new Date(dateStr);
      d.setMilliseconds(0);
      return d.getTime();
    };

    const pubTime = getSecondsOnly(publishedAt);
    const updTime = updatedAt ? getSecondsOnly(updatedAt) : 0;

    // Now, 'Has changes' only triggers if the update is at least 1 full second later
    if (updTime > pubTime) {
      return 'Has changes';
    }

    // 3. Published: Published, with no newer updates pending
    return 'Published';
  }
}
